// extracted by mini-css-extract-plugin
module.exports = {"container":"OutOfStockFilter_container__urUP6","label":"OutOfStockFilter_label__Rxa9E"};